import { PlaceStore } from "@/types/store";
import { Place } from "@/types/type";
import { create } from "zustand";

export const usePlaceStore = create<PlaceStore>((set) => ({
  places: [],
  selectedPlace: null,
  setPlaces: (places: Place[]) => set({ places }),
  setSelectedPlace: (place: Place) => set({ selectedPlace: place }),
  clearSelectedPlace: () => set({ selectedPlace: null }),
}));
